import { Categoria } from '../../types/catalogo';

interface Props {
  categorias: Categoria[];
  categoriaSeleccionada?: string;
  onSeleccionar: (categoriaId?: string) => void;
}

export function CategoryFilter({ categorias, categoriaSeleccionada, onSeleccionar }: Props) {
  return (
    <div className="flex gap-2.5 flex-wrap">
      <button
        onClick={() => onSeleccionar(undefined)}
        data-testid="category-filter-todos"
        className={`px-5 py-2.5 rounded-full text-[13px] font-semibold ${
          !categoriaSeleccionada ? 'bg-terracotta text-white' : 'bg-surface border border-border text-ink'
        }`}
      >
        Todos
      </button>
      {categorias.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSeleccionar(cat.id)}
          data-testid={`category-filter-${cat.id}`}
          className={`px-5 py-2.5 rounded-full text-[13px] font-semibold ${
            categoriaSeleccionada === cat.id
              ? 'bg-terracotta text-white'
              : 'bg-surface border border-border text-ink'
          }`}
        >
          {cat.nombre}
        </button>
      ))}
    </div>
  );
}
